class OAuthService {
  constructor() {}

  // Generic OAuth consent submit (multi-client version of the Zapier flow).
  // Returns {data:{success, code, redirectUri}} on success or
  // {data:{success:false, message}} on failure.
  async AuthorizeAccess(username, password, clientId, redirectUri, scope, pkce = {}) {
    if (username.length === 0 || password.length === 0) {
      window.$A.AlertUser("Please Fill Out The Login Form First", "warning");
      return {
        data: {
          success: false,
        },
      };
    }

    try {
      let response = await window.$A.Api.post("/oauth/authorize", {
        Email: username,
        Password: password,
        ClientId: clientId,
        RedirectUri: redirectUri,
        Scope: scope,
        Resource: pkce.resource,
        CodeChallenge: pkce.code_challenge,
        CodeChallengeMethod: pkce.code_challenge_method,
      });

      return response;
    } catch (error) {
      return {
        data: {
          success: false,
        },
      };
    }
  }
}

export default OAuthService;
